import React, { useState, useEffect, useCallback } from "react";
import {
  Breadcrumb,
  Flex,
  Row,
  Col,
  Space,
  Image,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  Button,
  Empty,
  ColorPicker,
  message,
  Switch,
  Tabs,
  Badge,
  Modal,
  Card,
  Radio,
  Checkbox,
  Divider,
} from "antd";
import {
  PlusOutlined,
  StarOutlined,
  EyeOutlined,
  UploadOutlined,
  LoadingOutlined,
  DatabaseOutlined,
  InfoCircleOutlined,
  GiftOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { getApi, postApi } from "../services/api.jsx";
import magic from "../assets/img/magic.png";
import ReactQuill from "react-quill";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import "react-quill/dist/quill.snow.css";
import TabPane from "antd/es/tabs/TabPane.js";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CriteriaRow from "../components/criteriaRow.jsx";
import Criteria from '../components/Criteria';
const s3BaseURL = process.env.REACT_APP_S3_BASE_URL;

const BadgeEditor = () => {
  const { Option } = Select;
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const rewardImageURL = Form.useWatch("rewardImageURL", form);
  const [buttonColor, setButtonColor] = useState("#F35454");
  const [buttonTextColor, setButtonTextColor] = useState("#ffffff");
  const [fontColor, setFontColor] = useState("#ffffff");
  const [backgroundColor, setBackgroundColor] = useState("#0E0F11");
  const [loading, setLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [backgroundImageURL, setBackgroundImageURL] = useState();
  const [badgeStatus, setBadgeStatus] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [type, setType] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formValues, setFormValues] = useState();
  const [recordCount, setRecordCount] = useState(0);
  const [headlineFontColor, setHeadlineFontColor] = useState("#ffffff");
  const [columnNames, setColumnNames] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [operators] = useState(['=', '<>', '>', '>=', '<', '<=', 'IN', 'NOT IN', 'LIKE', 'NOT LIKE', 'CONTAINS', 'NOT CONTAINS', 'IS NULL', 'IS NOT NULL', 'BETWEEN', 'NOT BETWEEN']);
  const [generatedSQL, setGeneratedSQL] = useState('');

  const [criteriaGroups, setCriteriaGroups] = useState([{
    id: uuidv4(),
    logicType: 'And',
    isNot: false,
    criteria: [{
      id: uuidv4(),
      columnName: undefined,
      operator: undefined,
      values: [undefined]
    }]
  }]);


  const [suppressionCriteriaGroups, setSuppressionCriteriaGroups] = useState([{
    id: uuidv4(),
    logicType: 'And',
    isNot: false,
    criteria: [{
      id: uuidv4(),
      columnName: undefined,
      operator: undefined,
      values: [undefined]
    }]
  }]);


  const [generatedSuppressionSQL, setGeneratedSuppressionSQL] = useState('');
  const [selectionMetadata, setSelectionMetadata] = useState([]);
  const [suppressionMetadata, setSuppressionMetadata] = useState([]);
  const [columnTypes, setColumnTypes] = useState({});
  const [isColumnLoading, setIsColumnLoading] = useState(false);
  const [isMetaDataLoading, setIsMetaDataLoading] = useState(false);


  useEffect(() => {
    getCategoryList();
    getDataSourceList();
    form.setFieldsValue({ expireDate: moment(new Date("2099-01-01")) });
  }, []);

  const getDataSourceList = () => {
    getApi("/badge/datasource")
      .then((dataSources) => {
        setDatasource(dataSources);
      })
      .catch((ex) => {
        console.error("Error fetching datasource list:", ex);
      });
  };

  const getColumnNames = (dataSource) => {
    if (!dataSource) return;
    setIsColumnLoading(true);
    getApi(`/badge/columnNames?datasource=${dataSource}`)
      .then((columns) => {
        setColumnNames(columns);
        const types = columns.reduce((acc, column) => {
          acc[column.columnName] = column.columnDataType;
          return acc;
        }, {});
        setColumnTypes(types);
      })
      .catch((ex) => {
        console.error("Error fetching column names:", ex);
      })
      .finally(() => {
        setIsColumnLoading(false);
      });
    setIsDataLoading(false);
  };

  const getMetaData = async (datasource, columnName, isSelection) => {
    setIsMetaDataLoading(true);
    if (!datasource || !columnName) return;
    try {
      const data = await getApi(`/badge/metadata?datasource=${datasource}&columnName=${columnName}`);
      if (isSelection) {
        setSelectionMetadata(prev => ({
          ...prev,
          [columnName]: data
        }));
      } else {
        setSuppressionMetadata(prev => ({
          ...prev,
          [columnName]: data
        }));
      }
      return data;
    } catch (error) {
      console.error('Error fetching metadata:', error);

      throw error;
    } finally {
      setIsMetaDataLoading(false);
    }
  };

  const handleColumnChange = async (value, isSelection) => {
    if (!value) return;
    const selectedDatasource = form.getFieldValue('dataSource');

    try {
      await getMetaData(selectedDatasource, value, isSelection);

      if (isSelection) {
        const sql = generateSQL(criteriaGroups);
        setGeneratedSQL(sql);
      } else {
        const sql = generateSQL(suppressionCriteriaGroups);
        setGeneratedSuppressionSQL(sql);
      }
    } catch (error) {
      console.error('Error in handleColumnChange:', error);
    }
  };

  const handleDataSourceChange = (value) => {



    form.setFieldsValue({ dataSource: value });

    getColumnNames(value);

    setCriteriaGroups([{
      id: uuidv4(),
      logicType: 'And',
      isNot: false,
      criteria: [{
        id: uuidv4(),
        columnName: undefined,
        operator: undefined,
        values: [undefined]
      }]
    }]);


    setSuppressionCriteriaGroups([{
      id: uuidv4(),
      logicType: 'And',
      isNot: false,
      criteria: [{
        id: uuidv4(),
        columnName: undefined,
        operator: undefined,
        values: [undefined]
      }]
    }]);
    setGeneratedSQL('');
    setGeneratedSuppressionSQL('');
    setSelectionMetadata([]);
    setSuppressionMetadata([]);
    setColumnTypes({});
  };

  const generateSQL = useCallback((groups) => {

    const generateGroupSQL = (group) => {
      if (!group.criteria || group.criteria.length === 0) return '';

      const criteriaSQL = group.criteria.map(criteria => {
        if (criteria.type === 'group') {
          const nestedSQL = generateGroupSQL(criteria);
          return nestedSQL ? `(${nestedSQL})` : '';
        }

        if (!criteria.columnName || !criteria.operator) return '';
        if (['IS NULL', 'IS NOT NULL'].includes(criteria.operator)) {
          return `${criteria.columnName} ${criteria.operator}`;
        }
        if (!criteria.values || (!criteria.values[0] && !['IN', 'NOT IN'].includes(criteria.operator))) return '';

        const columnType = columnTypes[criteria.columnName];

        if (columnType === 'TIMESTAMP' || columnType === 'DATE') {
          if (['BETWEEN', 'NOT BETWEEN'].includes(criteria.operator)) {
            if (criteria.values.length === 2 && criteria.values[0] && criteria.values[1]) {
              return `${criteria.columnName} ${criteria.operator} '${criteria.values[0]}' AND '${criteria.values[1]}'`;
            }
            return '';
          }

          if (['=', '<>', '>', '>=', '<', '<='].includes(criteria.operator)) {
            if (criteria.values[0]) {
              return `${criteria.columnName} ${criteria.operator} '${criteria.values[0]}'`;
            }
            return '';
          }
        }

        const formatValue = (value) => {
          if (value === null || value === undefined || value === '') {
            return 'NULL';
          }

          const isNumeric = columnType === 'INTEGER' ||
            columnType === 'NUMBER' ||
            columnType === 'FLOAT' ||
            columnType === 'DECIMAL';

          if (isNumeric && !isNaN(Number(value))) {
            return value;
          }

          if (['LIKE', 'NOT LIKE'].includes(criteria.operator)) {
            return `'${value}'`;
          }

          if (['CONTAINS', 'NOT CONTAINS'].includes(criteria.operator)) {
            return `'${value}'`;
          }

          return `'${value}'`;
        };

        switch (criteria.operator) {
          case 'IN':
            if (!criteria.values || criteria.values.length === 0) {
              return `${criteria.columnName} IN (NULL)`;
            }
            return `${criteria.columnName} IN (${criteria.values.map(v => formatValue(v)).join(', ')})`;

          case 'NOT IN':
            if (!criteria.values || criteria.values.length === 0) {
              return `${criteria.columnName} NOT IN (NULL)`;
            }
            return `${criteria.columnName} NOT IN (${criteria.values.map(v => formatValue(v)).join(', ')})`;

          case 'BETWEEN':
          case 'NOT BETWEEN':
            if (!criteria.values || criteria.values.length < 2 || !criteria.values[0] || !criteria.values[1]) {
              return '';
            }
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])} AND ${formatValue(criteria.values[1])}`;

          case 'CONTAINS':
            return `CONTAINS(${criteria.columnName}, ${formatValue(criteria.values[0])})`;

          case 'NOT CONTAINS':
            return `NOT CONTAINS(${criteria.columnName}, ${formatValue(criteria.values[0])})`;

          case 'LIKE':
          case 'NOT LIKE':
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])}`;

          default:
            return `${criteria.columnName} ${criteria.operator} ${formatValue(criteria.values[0])}`;
        }
      }).filter(sql => sql !== '');

      if (criteriaSQL.length === 0) return '';

      let sql = criteriaSQL.join(` ${group.logicType} `);
      if (group.isNot) {
        sql = `NOT (${sql})`;
      }

      return group.criteria.some(c => c.type === 'group') ? `(${sql})` : sql;
    };

    const mainSQL = groups.map(group => generateGroupSQL(group))
      .filter(sql => sql !== '')
      .join(' AND ');

    return mainSQL || '';
  }, [columnTypes]);

  const handleColorChange = (color, setter) => {
    const hexValue = typeof color === "string" ? color : color?.toHexString();
    setter(hexValue);
  };

  const handleCategoryChange = (value) => {
    const selectedCategoryId = value;
    const selectedCategory = categoryList.find(
      (category) => category.id === selectedCategoryId
    );
    setType(selectedCategory.name);
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG/WEBP file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const [previewData, setPreviewData] = useState({
    headline: "",
    description: "",
    imageURL: "",
    videoURL: "",
    bacgroundColor: "",
    font: "",
    fontColor: "",
    buttonLinkURL: "",
    buttonName: "",
    buttonColor: "",
    buttonTextColor: "",
    headlineFontColor: "",
    headlineFontSize: "",
    fontSize: "",
  });

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "code"],
      [{ 'color': [] }, { 'background': [] }],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false
    },
    keyboard: {
      bindings: {
        handleEnter: {
          key: 13,
          handler: function (range, context) {
            if (context.format.header) {
              this.quill.format('header', context.format.header);
            }
            return true;
          }
        }
      }
    }
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "code",
    "color",
    "background",
  ];

  const TextEditor = ({ value, onChange, placeholder }) => {
    const handleChange = (content) => {
      const cleanContent = content.replace(/<p><\/p>\s*<h[1-6]/g, '<h');
      if (onChange) {
        onChange(cleanContent);
      }
    };

    return (
      <ReactQuill
        theme="snow"
        value={value || ""}
        modules={modules}
        formats={formats}
        onChange={handleChange}
        placeholder={placeholder}
      />
    );
  };

  const getCategoryList = () => {
    getApi("/category/list").then((categoryList) => {
      setCategoryList(categoryList);
    });
  };

  const handleFormSubmit = (values) => {
    setFormValues(values);
    let criteriaCountURL = "/badge/criteriaCount?";
    if (values.dataSource) {
      criteriaCountURL += "dataSource=" + encodeURIComponent(values.dataSource);
    }
    if (generatedSQL) {
      const encodedSQL = encodeURIComponent(generatedSQL);
      criteriaCountURL += "&selectionCriteria=" + encodedSQL;
    }
    if (generatedSuppressionSQL) {
      const encodedSuppressionSQL = encodeURIComponent(generatedSuppressionSQL);
      criteriaCountURL += "&suppressionCriteria=" + encodedSuppressionSQL;
    }
    setLoading(true);
    getApi(criteriaCountURL)
      .then((count) => {
        setRecordCount(count);
        setIsModalVisible(true);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Error on checking criteria record count",
          error,
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const createBadge = () => {
    const values = formValues;
    setLoading(true);
    const badgeData = {
      ...values,
      selectionCriteria: generatedSQL,
      suppressionCriteria: generatedSuppressionSQL,
      createdBy: localStorage.getItem("userEmail"),
      lastUpdatedBy: localStorage.getItem("userEmail"),
      type: type,
      imageURL: imageUrl,
      backgroundImageURL: backgroundImageURL,
      headlineFontColor: values.headlineFontColor,
      headlineFontSize: values.headlineFontSize,
      fontSize: values.fontSize,
      expireDate: moment(values.expireDate.format("YYYY-MM-DD")),
      rewardDescription: values.rewardDescription,
      rewardDescriptionFontSize: values.rewardDescriptionFontSize,
      rewardDescriptionFontColor: values.rewardDescriptionFontColor,
      rewardHeadline: values.rewardHeadline,
      rewardHeadlineFontSize: values.rewardHeadlineFontSize,
      rewardHeadlineFontColor: values.rewardHeadlineFontColor,
      rewardImageURL: values.rewardImageURL,
    };


    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'badge_create',
      'badge_name': values.name,
      'category': type,
      'user_email': localStorage.getItem("userEmail"),
      'create_timestamp': new Date().toISOString(),
      'ga4_measurement_id': 'G-EC4X5M443P'
    });


    if (window.gtag) {
      window.gtag('event', 'badge_create', {
        'badge_name': values.name,
        'category': type,
        'user_email': localStorage.getItem("userEmail"),
        'create_timestamp': new Date().toISOString()
      });
    }

    //Base64 Check
    if ("imageURL" && "backgroundImageURL" in values) {
      delete values.imageUrl;
      delete values.backgroundImageURL;
    }
    postApi("/badge", badgeData)
      .then((data) => {
        Swal.fire({
          title: "Success!",
          text: "Badge Created!",
          icon: "success",
        });
        navigate(`/badge-edit/${data.id}`);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Error creating badge",
          error,
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
        setIsModalVisible(false);
      });
  };

  const badgePreview = () => {
    form
      .validateFields([
        "headline",
        "description",
        "imageURL",
        "backgroundImageURL",
        "videoURL",
        "buttonName",
        "buttonTextColor",
        "buttonColor",
        "buttonLinkURL",
        "headlineFontColor",
        "headlineFontSize",
        "fontSize"
      ])
      .then((values) => {
        setPreviewData(values);
      })
      .catch((error) => {
        console.log("Error in form:", error);
      });
  };

  const badgeFormStatusControl = () => {
    const values = form.getFieldsValue(["dataSource", "selectionCriteria"]);
    if (values.dataSource && values.selectionCriteria) {
      setBadgeStatus("success");
    } else {
      setBadgeStatus("error");
    }
  };

  const handleFormValuesChange = () => {
    badgePreview();
    badgeFormStatusControl();
  };
  const handleBadgeImageChange = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        let imageUrl = s3BaseURL + info.file.originFileObj.name;
        setImageUrl(imageUrl);
      });
    }
  };
  const handleRemoveBadgeImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setImageUrl(undefined);
    form.setFieldValue("imageURL", undefined);
    handleFormValuesChange();
  };
  const handleRemoveRewardImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    form.setFieldValue("rewardImageURL", undefined);
    handleFormValuesChange();
  };
  const handleBackgroundImageChange = (info) => {
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        let backgroundImageURL = s3BaseURL + info.file.originFileObj.name;
        setBackgroundImageURL(backgroundImageURL);
      });
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const uploadImage = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      postApi("/file", formData, "multipart/form-data").then((data) => {
        onSuccess(data, file);
      });
      Swal.fire({
        title: "Success!",
        text: `${file.name} uploaded successfully`,
        icon: "success",
      });
    } catch (error) {
      onError(error);
      Swal.fire({
        title: "Error!",
        text: `${file.name} upload failed`,
        icon: "error",
      });
    }
  };

  const uploadVideo = async ({ file, onSuccess, onError }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      const response = await postApi("/file/multipart", formData, "multipart/form-data");
      
      onSuccess(response, file);
      
      const videoUrl = `https://orlando-magic-badge-dev1.s3.amazonaws.com/${file.name}`;
      form.setFieldValue('videoURL', videoUrl);
      badgePreview();
      
      Swal.fire({
        title: "Success!",
        text: `${file.name} uploaded successfully`,
        icon: "success",
      });
    } catch (error) {
      onError(error);
      Swal.fire({
        title: "Error!",
        text: `${file.name} upload failed`,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);
  const props = {
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png";
      if (!isPNG) {
        message.error(`${file.name} is not a png file`);
      }
      return isPNG || Upload.LIST_IGNORE;
    }
  };
  const handleRemoveBackgroundImage = () => {
    setBackgroundImageURL("");
  };

  const isYouTubeURL = (url) => {
    return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+/.test(url);
  };

  const handleAddCriteria = (groupId) => {
    setCriteriaGroups(prevGroups => {
      return updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: [...group.criteria, {
          id: uuidv4(),
          type: 'rule',
          columnName: undefined,
          operator: undefined,
          values: [undefined]
        }]
      }));
    });
  };

  const handleUpdateSuppressionCriteria = (groupId, criteriaId, field, value) => {
    setSuppressionCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: group.criteria.map(criteria => {
          if (criteria.id === criteriaId) {
            const updatedCriteria = {
              ...criteria,
              [field]: field === 'values' ? [value] : value
            };
            return updatedCriteria;
          }
          return criteria;
        })
      }));

      const sql = generateSQL(newGroups);
      setGeneratedSuppressionSQL(sql);
      return newGroups;
    });
  };
  const handleAddSuppressionCriteria = (groupId) => {
    setSuppressionCriteriaGroups(prevGroups => {
      return updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: [...group.criteria, {
          id: uuidv4(),
          type: 'rule',
          columnName: undefined,
          operator: undefined,
          values: [undefined]
        }]
      }));
    });
  };

  const handleAddSuppressionGroup = (parentGroupId) => {
    const newGroup = {
      id: uuidv4(),
      type: 'group',
      logicType: 'And',
      isNot: false,
      criteria: [{
        id: uuidv4(),
        type: 'rule',
        columnName: undefined,
        operator: undefined,
        values: [undefined]
      }]
    };

    setSuppressionCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, parentGroupId, (group) => ({
        ...group,
        criteria: [...group.criteria, newGroup]
      }));

      const sql = generateSQL(newGroups);
      setGeneratedSuppressionSQL(sql);
      return newGroups;
    });
  };

  const CriteriaGroup = ({ group, onUpdate, onDelete, level = 0, parentLogicType, isSelectionCriteria, onCriteriaUpdate, columnNames, operators, metadata, onColumnChange, columnTypes }) => {
    const getBackgroundColor = (level) => {
      const colors = [
        'white',
        '#fafafa',
        '#f5f5f5',
        '#f0f0f0',
        '#e8e8e8',
      ];
      return colors[Math.min(level, colors.length - 1)];
    };

    const previousItemIsRule = () => {
      const previousItem = group.criteria[0]?.type;
      return !previousItem;
    };

    return (
      <>
        {level > 0 && !previousItemIsRule() && (
          <Divider
            plain
            orientation="center"
            style={{
              margin: '12px 0',
              fontSize: '13px',
              fontWeight: '500',
              color: '#8d8989',
            }}
          >
            {parentLogicType.toUpperCase()}
          </Divider>
        )}
        <Card
          title={
            <Flex justify="space-between" align="center">
              <Flex justify="start" align="center" gap={10}>
                <Radio.Group
                  value={group.logicType}
                  onChange={(e) => {
                    onUpdate(group.id, 'logicType', e.target.value);
                    const sql = generateSQL(criteriaGroups);
                    setGeneratedSQL(sql);
                  }}
                  buttonStyle="solid"
                >
                  <Radio.Button value="And">AND</Radio.Button>
                  <Radio.Button value="Or">OR</Radio.Button>
                </Radio.Group>
                <Checkbox
                  checked={group.isNot}
                  onChange={(e) => onUpdate(group.id, 'isNot', e.target.checked)}
                >
                  NOT
                </Checkbox>
              </Flex>
              <Flex justify="end" align="center" gap={10}>
                <Button
                  type="default"
                  icon={<PlusOutlined />}
                  size="small"
                  onClick={() => {
                    if (isSelectionCriteria) {
                      handleAddCriteria(group.id);
                    } else {
                      handleAddSuppressionCriteria(group.id);
                    }
                  }}
                >
                  Add Rule
                </Button>
                <Button
                  type="dashed"
                  icon={<PlusOutlined />}
                  size="small"
                  onClick={() => {
                    if (isSelectionCriteria) {
                      handleAddGroup(group.id);
                    } else {
                      handleAddSuppressionGroup(group.id);
                    }
                  }}
                >
                  Add Group
                </Button>
                {level > 0 && (
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onDelete(group.id)}
                  />
                )}
              </Flex>
            </Flex>
          }
          style={{
            marginBottom: '20px',
            backgroundColor: group.isNot ? '#fff2f0' : getBackgroundColor(level)
          }}
        >
          {group.criteria.map((criteria, index) => (
            <React.Fragment key={criteria.id}>
              {criteria.type === 'group' ? (
                <CriteriaGroup
                  group={criteria}
                  onUpdate={handleUpdateNestedGroup}
                  onDelete={handleDeleteGroup}
                  level={level + 1}
                  parentLogicType={group.logicType}
                  isSelectionCriteria={isSelectionCriteria}
                  onCriteriaUpdate={onCriteriaUpdate}
                  columnNames={columnNames}
                  operators={operators}
                  metadata={metadata}
                  onColumnChange={(value) => {
                    onColumnChange(value);
                    if (isSelectionCriteria) {
                      handleUpdateCriteria(group.id, criteria.id, 'columnName', value);
                    } else {
                      handleUpdateSuppressionCriteria(group.id, criteria.id, 'columnName', value);
                    }
                  }}
                  isLoading={isDataLoading}
                  columnTypes={columnTypes}
                />
              ) : (
                <CriteriaRow
                  criteria={criteria}
                  columnNames={isSelectionCriteria ? columnNames : columnNames}
                  operators={operators}
                  isColumnLoading={isColumnLoading}
                  isMetaDataLoading={isMetaDataLoading}
                  metadata={isSelectionCriteria ? selectionMetadata : suppressionMetadata}
                  onColumnChange={(value) => {
                    onColumnChange(value);
                    if (isSelectionCriteria) {
                      handleUpdateCriteria(group.id, criteria.id, 'columnName', value);
                    } else {
                      handleUpdateSuppressionCriteria(group.id, criteria.id, 'columnName', value);
                    }
                  }}
                  onUpdate={(field, value) => {
                    if (isSelectionCriteria) {
                      handleUpdateCriteria(group.id, criteria.id, field, value);
                    } else {
                      handleUpdateSuppressionCriteria(group.id, criteria.id, field, value);
                      const newGroups = updateNestedGroups(suppressionCriteriaGroups, group.id, (g) => ({
                        ...g,
                        criteria: g.criteria.map(c => {
                          if (c.id === criteria.id) {
                            return { ...c, [field]: field === 'values' ? [value] : value };
                          }
                          return c;
                        })
                      }));
                      const sql = generateSQL(newGroups);
                      setGeneratedSuppressionSQL(sql);
                    }
                  }}
                  onDelete={() => {
                    if (isSelectionCriteria) {
                      handleDeleteCriteria(group.id, criteria.id);
                    } else {
                      handleDeleteSuppressionCriteria(group.id, criteria.id);
                    }
                  }}
                  isSelectionCriteria={isSelectionCriteria}
                  columnTypes={columnTypes}
                />
              )}
              {index < group.criteria.length - 1 && (
                <Divider
                  plain
                  orientation="center"
                  style={{
                    margin: '8px 0',
                    fontSize: '13px',
                    fontWeight: '500',
                    color: '#8d8989',
                  }}
                >
                  {group.logicType.toUpperCase()}
                </Divider>
              )}
            </React.Fragment>
          ))}
        </Card>
      </>
    );
  };

  const handleAddGroup = (parentGroupId) => {
    const newGroup = {
      id: uuidv4(),
      type: 'group',
      logicType: 'And',
      isNot: false,
      criteria: [{
        id: uuidv4(),
        columnName: undefined,
        operator: undefined,
        values: [undefined]
      }]
    };

    setCriteriaGroups(prevGroups => {
      return updateNestedGroups(prevGroups, parentGroupId, (group) => ({
        ...group,
        criteria: [...group.criteria, newGroup]
      }));
    });
  };

  const handleUpdateNestedGroup = (groupId, field, value) => {
    setCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        [field]: value
      }));

      const sql = generateSQL(newGroups);
      setGeneratedSQL(sql);
      return newGroups;
    });
  };

  const handleDeleteGroup = (groupId) => {
    setCriteriaGroups(prevGroups => {
      const newGroups = deleteNestedGroup(prevGroups, groupId);
      const sql = generateSQL(newGroups);
      setGeneratedSQL(sql);
      return newGroups;
    });
  };

  const updateNestedGroups = (groups, targetId, updateFn) => {
    return groups.map(group => {
      if (group.id === targetId) {
        return updateFn(group);
      }
      if (group.criteria) {
        return {
          ...group,
          criteria: updateNestedGroups(group.criteria, targetId, updateFn)
        };
      }
      return group;
    });
  };

  const deleteNestedGroup = (groups, targetId) => {
    return groups.filter(group => {
      if (group.id === targetId) {
        return false;
      }
      if (group.criteria) {
        group.criteria = deleteNestedGroup(group.criteria, targetId);
      }
      return true;
    });
  };

  const handleUpdateCriteria = (groupId, criteriaId, field, value) => {
    setCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: group.criteria.map(criteria => {
          if (criteria.id === criteriaId) {
            const updatedCriteria = { ...criteria };

            if (field === 'values') {
              updatedCriteria.values = Array.isArray(value) ? value : [value];
            } else {
              updatedCriteria[field] = value;
            }
            return updatedCriteria;
          }
          return criteria;
        })
      }));
      const sql = generateSQL(newGroups);
      setGeneratedSQL(sql);
      return newGroups;
    });
  };

  const handleDeleteCriteria = (groupId, criteriaId) => {
    setCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: group.criteria.filter(criteria => criteria.id !== criteriaId)
      }));
      const sql = generateSQL(newGroups);
      setGeneratedSQL(sql);
      return newGroups;
    });
  };



  const handleDeleteSuppressionCriteria = (groupId, criteriaId) => {
    setSuppressionCriteriaGroups(prevGroups => {
      const newGroups = updateNestedGroups(prevGroups, groupId, (group) => ({
        ...group,
        criteria: group.criteria.filter(c => c.id !== criteriaId)
      }));

      const sql = generateSQL(newGroups);
      setGeneratedSuppressionSQL(sql);


      return newGroups;
    });
  };

  useEffect(() => {
    const sql = generateSQL(criteriaGroups);
    setGeneratedSQL(sql);
  }, [criteriaGroups, generateSQL]);

  useEffect(() => {
    const sql = generateSQL(suppressionCriteriaGroups);
    setGeneratedSuppressionSQL(sql);
  }, [suppressionCriteriaGroups, generateSQL]);
  const resetBadgeInfoTab = () => {
    form.resetFields([
      "name",
      "headline",
      "headlineFontColor",
      "headlineFontSize",
      "categoryId",
      "description",
      "hoverDescription",
      "videoURL",
      "uploadVideo",
      "altText",
      "backgroundColor",
      "backgroundImageURL",
      "font",
      "fontColor",
      "fontSize",
      "buttonName",
      "buttonLinkURL",
      "buttonColor",
      "buttonTextColor",
      "hasReward",
      "promoUuid",
      "isDisplayUnearned",
      "publishDate",
      "expireDate",
    ]);
    form.setFieldsValue({
      headlineFontColor: "#ffffff",
      backgroundColor: "#1E222B",
      fontColor: "#ffffff",
      buttonColor: "#ffffff",
      buttonTextColor: "#ffffff",
    });
    setButtonColor("#ffffff");
    setButtonTextColor("#ffffff");
    setFontColor("#ffffff");
    setBackgroundColor("#1E222B");
    setHeadlineFontColor("#ffffff");
  };

  const resetRewardTab = () => {
    form.resetFields([
      "rewardHeadline",
      "rewardHeadlineFontColor",
      "rewardHeadlineFontSize",
      "rewardDescription",
      "rewardDescriptionFontColor",
      "rewardDescriptionFontSize",
    ]);
    form.setFieldsValue({
      rewardHeadlineFontColor: "#ffffff",
      rewardDescriptionFontColor: "#ffffff",
    });
  };

  const resetData = () => {
    form.setFieldsValue({
      dataSource: undefined,
      selectionCriteria: '',
    });

    setCriteriaGroups([{
      id: uuidv4(),
      type: 'group',
      logicType: 'And',
      isNot: false,
      criteria: []
    }]);
    setGeneratedSQL('');
    setBadgeStatus('error');
  };


  return (
    <div>
      <Flex
        gap="middle"
        align="center"
        justify="space-between"
        className="page-header"
      >
        <h2>Create New Badge</h2>
        <Breadcrumb
          items={[
            {
              title: "Home",
            },
            {
              title: "Create",
            },
            {
              title: <a href="/badge-editor">Badge</a>,
            },
          ]}
        />
      </Flex>

      <Row style={{ padding: "20px 10px" }}>
        <Col span={16}>
          <Form
            form={form}
            onFinish={handleFormSubmit}
            onValuesChange={handleFormValuesChange}
            scrollToFirstError
            name="validateOnly"
            layout="vertical"
            autoComplete="off"
            initialValues={{ imageURL: imageUrl }}
          >
            <Tabs defaultActiveKey="1">
              <TabPane
                tab={
                  <span>
                    <StarOutlined className="me-5" />
                    Badge Info
                  </span>
                }
                key="1"
              >
                <Flex>
                  <Flex style={{ width: "45%", marginRight: "3%" }} vertical>
                    <Form.Item
                      name="imageURL"
                      label="Badge Image"
                      rules={[
                        { required: true, message: "Please upload image!" },
                      ]}
                    >
                      <Upload
                        name="imageURL"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        onChange={handleBadgeImageChange}
                      >
                        {imageUrl ? (
                          <div style={{ position: "relative", width: "100%" }}>
                            <img
                              src={imageUrl}
                              alt="avatar"
                              style={{
                                width: "95%",
                              }}
                            />
                            <Button
                              danger
                              shape="circle"
                              size="small"
                              icon={<DeleteOutlined />}
                              title="Remove image"
                              onClick={handleRemoveBadgeImage}
                              style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                              }}
                            />
                          </div>
                        ) : (
                          uploadButton
                        )}
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Badge Name"
                      rules={[
                        { required: true, message: "Please input badge name!" },
                      ]}
                    >
                      <Input placeholder="input badge name" />
                    </Form.Item>
                    <Form.Item
                      name="headline"
                      label="Headline"
                      rules={[
                        { required: true, message: "Please select category!" },
                      ]}
                    >
                      <Input placeholder="input headline " />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="headlineFontColor"
                        style={{ width: "200px" }}
                        label="Headline Font Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={headlineFontColor}
                          onChange={(color) => handleColorChange(color, setHeadlineFontColor)}
                        />
                      </Form.Item>

                      <Form.Item
                        name="headlineFontSize"
                        style={{ width: "200px", marginLeft: "20px" }}
                        label="Headline Font Size"
                      >
                        <Input
                          type="number"
                          min={1}
                          placeholder="Ente font size"
                          addonAfter="px"
                        />
                      </Form.Item>
                    </Flex>
                    <Form.Item
                      name="categoryId"
                      label="Category"
                      rules={[
                        { required: true, message: "Please select category!" },
                      ]}
                    >
                      <Select
                        placeholder="Select badge category"
                        onChange={(value) => handleCategoryChange(value)}
                      >
                        {categoryList.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="description"
                      label="Badge Description"
                      maxLength="100"
                      rules={[
                        {
                          required: true,
                          message: "Please input badge description!",
                        },
                      ]}
                    >
                      <TextEditor />
                    </Form.Item>
                    <Form.Item
                      name="hoverDescription"
                      label="Hover Badge Description"
                      maxLength="100"
                      rules={[
                        {
                          required: false
                        }
                      ]}
                    >
                      <TextEditor />
                    </Form.Item>
                  </Flex>

                  <Flex vertical>
                    <Form.Item name="videoURL" label="Video/Image URL">
                      <Input placeholder="Enter embed video URL" />
                    </Form.Item>
                    <Form.Item name="uploadVideo" label="Upload Video">
                      <Upload
                        customRequest={uploadVideo}
                        showUploadList={true}
                      >
                        <Button icon={<UploadOutlined />}>Upload Video</Button>
                      </Upload>
                    </Form.Item>

                    <Form.Item name="altText" label="Alt Text">
                      <Input placeholder="input alt text " />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="backgroundColor"
                        className="ms-5"
                        label="Background Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: "select background color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="#1E222B"
                          value={backgroundColor}
                          onChange={(color) =>
                            handleColorChange(color, setBackgroundColor)
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        className="ms-5"
                        name="backgroundImageURL"
                        label="Background Image"
                        rules={[
                          { required: false, message: "Please select font!" },
                        ]}
                      >
                        <Upload
                          {...props}
                          showRemoveIcon={true}
                          onRemove={() => handleRemoveBackgroundImage()}
                          name="backgroundImageURL"
                          showUploadList={true}
                          customRequest={uploadImage}
                          beforeUpload={beforeUpload}
                          onChange={handleBackgroundImageChange}
                        >
                          <Button icon={<UploadOutlined />}>
                            Upload Image
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Flex>

                    <Flex>
                      <Form.Item
                        name="font"
                        style={{ width: "200px" }}
                        label="Font"
                        rules={[
                          { required: false, message: "Please select font!" },
                        ]}
                      >
                        <Select placeholder="select font">
                          <Option value="Poppins">Poppins</Option>
                          <Option value="Roboto">Roboto</Option>
                          <Option value="Custom">Custom</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="fontColor"
                        className="ms-5"
                        label="Font Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: " select font color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={fontColor}
                          onChange={(color) =>
                            handleColorChange(color, setFontColor)
                          }
                        />
                      </Form.Item>
                    </Flex>

                    <Form.Item
                      name="fontSize"
                      style={{ width: "200px" }}
                      label="Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>

                    <Form.Item
                      name="buttonName"
                      label="Button Name"
                      rules={[
                        {
                          required: false,
                          message: "Please input Button Name!",
                        },
                      ]}
                    >
                      <Input placeholder="input button name" />
                    </Form.Item>
                    <Form.Item
                      name="buttonLinkURL"
                      label="Button URL"
                      rules={[
                        {
                          required: false,
                          message: "Please input Button URL!",
                        },
                      ]}
                    >
                      <Input addonBefore="https://" />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        name="buttonColor"
                        className="ms-5"
                        label="Button Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: " select button color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={buttonColor}
                          onChange={(color) =>
                            handleColorChange(color, setButtonColor)
                          }
                        />
                      </Form.Item>

                      <Form.Item
                        name="buttonTextColor"
                        className="ms-5"
                        label="Button Text Color"
                        getValueFromEvent={(color) => {
                          return "#" + color.toHex();
                        }}
                        rules={[
                          {
                            required: false,
                            message: "Select button text color!",
                          },
                        ]}
                      >
                        <ColorPicker
                          showText
                          defaultValue="white"
                          value={buttonTextColor}
                          onChange={(color) =>
                            handleColorChange(color, setButtonTextColor)
                          }
                        />
                      </Form.Item>
                    </Flex>

                    <Form.Item
                      name="hasReward"
                      label="Is there a reward for this badge?"
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>

                    <Form.Item
                      name="promoUuid"
                      label="Promo UUID"
                      rules={[
                        {
                          required: false,
                          message: "Please input Promo UUID!",
                        },
                      ]}
                    >
                      <Input placeholder="Enter Promo UUID" />
                    </Form.Item>

                    <Form.Item
                      name="isDisplayUnearned"
                      label="Display Badge Even Unearned?"
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>
                    <Flex>
                      <Form.Item
                        className="me-5"
                        name="publishDate"
                        label="Publish Date"
                        rules={[
                          {
                            required: true,
                            message: "Please select publish date!",
                          },
                        ]}
                      >
                        <DatePicker showTime maxDate={dayjs("2028-01-01")} />
                      </Form.Item>
                      <Form.Item
                        name="expireDate"
                        label="Expire Date"
                        rules={[
                          {
                            required: false,
                            message: "Please select expiry date!",
                          },
                        ]}
                      >
                        <DatePicker maxDate={dayjs("2099-01-01")} />
                      </Form.Item>
                    </Flex>
                    <Form.Item>
                      <Space>
                        <Button
                          type="dashed"
                          shape="round"
                          danger
                          onClick={badgePreview}
                          icon={<EyeOutlined />}
                        >
                          Preview
                        </Button>
                        <Button
                          shape="round"
                          className="badge-btn-dark"
                          type="primary"
                          success
                          htmlType="submit"
                          icon={<StarOutlined />}
                        >
                          Save
                        </Button>
                        <Button
                          htmlType="button"
                          shape="round"
                          danger
                          onClick={resetBadgeInfoTab}
                        >
                          Reset
                        </Button>
                      </Space>
                    </Form.Item>
                  </Flex>
                </Flex>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <DatabaseOutlined className="me-5" />
                    Data
                  </span>
                }
                key="2"
              >
                <Flex style={{ width: "90%" }} vertical>
                  <Form.Item
                    name="dataSource"
                    label="Datasource"
                    rules={[
                      { required: true, message: "Please select datasource!" },
                    ]}
                  >
                    <Select
                      style={{ width: '300px' }}
                      placeholder="Select datasource"
                      onChange={handleDataSourceChange}
                    >
                      {datasource.map((dataSource) => (
                        <Option
                          key={dataSource}
                          value={dataSource}
                          label={dataSource}
                        >
                          {dataSource}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Criteria
                    title="Selection Criteria"
                    required={true}
                    criteriaGroups={criteriaGroups}
                    setCriteriaGroups={setCriteriaGroups}
                    generateSQL={generateSQL}
                    setGeneratedSQL={setGeneratedSQL}
                    columnNames={columnNames}
                    operators={operators}
                    metadata={selectionMetadata}
                    onColumnChange={(value) => handleColumnChange(value, true)}
                    isColumnLoading={isColumnLoading}
                    isMetaDataLoading={isMetaDataLoading}
                    columnTypes={columnTypes}
                    isSelectionCriteria={true}
                  />
                  {/* <Criteria
                    title="Suppression Criteria"
                    required={false}
                    criteriaGroups={suppressionCriteriaGroups}
                    setCriteriaGroups={setSuppressionCriteriaGroups}
                    generateSQL={generateSQL}
                    setGeneratedSQL={setGeneratedSuppressionSQL}
                    columnNames={columnNames}
                    operators={operators}
                    metadata={suppressionMetadata}
                    onColumnChange={(value) => handleColumnChange(value, false)}
                    isColumnLoading={isColumnLoading}
                    isMetaDataLoading={isMetaDataLoading}
                    columnTypes={columnTypes}
                    isSelectionCriteria={false}
                  /> */}
                  {/* <Form.Item
                    name="badgeStatusCalculation"
                    label="Badge Status Calculation"
                  >
                    <Input placeholder="Badge Status Calculation" />
                  </Form.Item>
                  <Form.Item
                    name="badgeStatusCompletionValue"
                    label="Badge Status Completion Value"
                  >
                    <Input placeholder="Badge Status Calculation" />
                  </Form.Item> */}
                  <Form.Item>
                    <Space>
                      <Button
                        shape="round"
                        className="badge-btn-dark"
                        type="primary"
                        success
                        htmlType="submit"
                        icon={<StarOutlined />}
                      >
                        Save
                      </Button>
                      <Button
                        htmlType="button"
                        shape="round"
                        danger
                        onClick={resetData}
                      >
                        Reset
                      </Button>
                    </Space>
                  </Form.Item>
                </Flex>
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <GiftOutlined className="me-5" />
                    Reward
                  </span>
                }
                key="3"
              >
                <Flex style={{ width: "60%" }} vertical>
                  <Form.Item
                    name="rewardImageURL"
                    label="Reward Image"
                  >
                    <Upload
                      name="rewardImageURL"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      customRequest={uploadImage}
                      beforeUpload={beforeUpload}
                      onChange={(info) => {
                        if (info.file.status === "done") {
                          const imageUrl = s3BaseURL + info.file.originFileObj.name;
                          form.setFieldValue('rewardImageURL', imageUrl);
                        }
                      }}
                    >
                      {rewardImageURL ? (
                        <div style={{ position: "relative", width: "100%" }}>
                          <img
                            src={rewardImageURL}
                            alt="reward"
                            style={{ width: '95%' }}
                          />
                          <Button
                            danger
                            shape="circle"
                            size="small"
                            icon={<DeleteOutlined />}
                            title="Remove image"
                            onClick={handleRemoveRewardImage}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                            }}
                          />
                        </div>
                      ) : uploadButton}
                    </Upload>
                  </Form.Item>
                  <Form.Item
                    name="rewardHeadline"
                    label="Reward Headline"
                  >
                    <Input placeholder="Enter reward headline" />
                  </Form.Item>

                  <Flex>
                    <Form.Item
                      name="rewardHeadlineFontColor"
                      style={{ width: "250px" }}
                      label="Reward Headline Font Color"
                      getValueFromEvent={(color) => {
                        return "#" + color.toHex();
                      }}
                    >
                      <ColorPicker showText />
                    </Form.Item>

                    <Form.Item
                      name="rewardHeadlineFontSize"
                      style={{ width: "200px", marginLeft: "20px" }}
                      label="Reward Headline Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>
                  </Flex>



                  <Form.Item
                    name="rewardDescription"
                    label="Reward Description"
                    maxLength="100"
                    rules={[
                      {
                        required: false,
                      },
                    ]}
                  >
                    <TextEditor />
                  </Form.Item>
                  <Flex>
                    <Form.Item
                      name="rewardDescriptionFontColor"
                      style={{ width: "250px" }}
                      label="Reward Description Font Color"
                      getValueFromEvent={(color) => {
                        return "#" + color.toHex();
                      }}
                    >
                      <ColorPicker showText />
                    </Form.Item>

                    <Form.Item
                      name="rewardDescriptionFontSize"
                      style={{ width: "250px", marginLeft: "20px" }}
                      label="Reward Description Font Size"
                    >
                      <Input
                        type="number"
                        min={1}
                        placeholder="Enter font size"
                        addonAfter="px"
                      />
                    </Form.Item>
                  </Flex>



                  <Form.Item>
                    <Space>
                      <Button
                        shape="round"
                        className="badge-btn-dark"
                        type="primary"
                        success
                        htmlType="submit"
                        icon={<StarOutlined />}
                      >
                        Save
                      </Button>
                      <Button
                        htmlType="button"
                        shape="round"
                        danger
                        onClick={resetRewardTab}
                      >
                        Reset
                      </Button>
                    </Space>
                  </Form.Item>
                </Flex>
              </TabPane>
            </Tabs>
          </Form>
        </Col>
        <Col span={8}>
          <Flex
            style={{
              backgroundImage: backgroundImageURL
                ? `url(${backgroundImageURL})`
                : "none",
              backgroundSize: "cover",
              backgroundColor: backgroundColor,
              color: fontColor,
            }}
            className="w-100 h-100 rounded-10"
            vertical
            justify="space-between"
          >
            {previewData.headline ? (
              <>
                <div className="text-center p-15">
                  <h3>Magic Badge Preview</h3>
                  <div className="night">
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                    <div className="star"></div>
                  </div>
                  <Image
                    src={imageUrl}
                    alt="Badge"
                    style={{
                      width: "150px",
                    }}
                  />
                  <h3 style={{
                    color: previewData.headlineFontColor || headlineFontColor,
                    fontSize: previewData.headlineFontSize ? `${previewData.headlineFontSize}px` : 'inherit',
                    fontFamily: previewData.font ? `"${previewData.font}"` : 'inherit'
                  }}>
                    {previewData.headline}
                  </h3>
                  <div
                    style={{
                      color: previewData.fontColor || fontColor,
                      fontSize: previewData.fontSize ? `${previewData.fontSize}px` : 'inherit',
                      fontFamily: previewData.font ? `"${previewData.font}"` : 'inherit'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: previewData.description,
                    }}
                  />
                  {previewData.buttonName && (
                    <Button
                      href={previewData.buttonLinkURL}
                      style={{
                        backgroundColor: previewData.buttonColor,
                        color: previewData.buttonTextColor,
                        border: 'none',
                        fontSize: previewData.fontSize ? `${previewData.fontSize}px` : 'inherit',
                        fontFamily: previewData.font ? `"${previewData.font}"` : 'inherit'
                      }}
                    >
                      {previewData.buttonName}
                    </Button>
                  )}
                </div>
                <div>
                  <>
                    {previewData.videoURL && (
                      isYouTubeURL(previewData.videoURL) ? (
                        <iframe
                          className="prev-video"
                          width="100%"
                          height="315"
                          src={previewData.videoURL.replace('watch?v=', 'embed/')}
                          title={previewData.name}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <video
                          className="prev-video"
                          width="100%"
                          height="315"
                          controls
                        >
                          <source src={previewData.videoURL} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )
                    )}
                  </>
                </div>
              </>
            ) : (
              <div className="flex-empty">
                <Empty
                  className=""
                  image={magic}
                  imageStyle={{ height: 150 }}
                  description={<span>Fill Out the Form and Click Preview</span>}
                ></Empty>
              </div>
            )}
          </Flex>
        </Col>
      </Row>
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner" />
        </div>
      )}

      <Modal
        /*         width="800px"
         */ title={
          <>
            <InfoCircleOutlined style={{ color: "red" }} />
            {"\tConfirmation"}
          </>
        }
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => createBadge()}
        okText={"Create Badge"}
      >
        <p>
          There are {recordCount} records with these criterias. Do you want to
          proceed to save badge with these criterias?
        </p>
      </Modal>
    </div>
  );
};

export default BadgeEditor;
